import { convertToQueryString } from 'app/shared/functions';
import { HttpClient } from 'app/library/client';
import { IListFilter, ResponseBase, ResponseContentBase, ResponseListBase } from "app/shared";
import { ActivityCommunityEntity } from './types';
import { getEndpoint } from 'app/utils/service';

export class ActivityCommunityService {

    /** It gets all ActivityCommunity. */
    async getActivityCommunities(options: IListFilter): Promise<ResponseBase<ResponseListBase<ActivityCommunityEntity[]>>> {
        return HttpClient.getClient().get(getEndpoint('/activity-community/search') + `?${convertToQueryString(options)}`);
    }

    /** It get spesific ActivityCommunity by ActivityCommunity id */
    async getActivityCommunity(id: string, language: string): Promise<ResponseBase<ResponseContentBase<ActivityCommunityEntity>>> {
        return HttpClient.getClient().get(getEndpoint('/activity-community/') + id + `?language=${language || "en"}`);
    }

    /** It creates ActivityCommunity by request */
    async createActivityCommunity(request: ActivityCommunityEntity): Promise<ResponseBase<ResponseContentBase<ActivityCommunityEntity>>> {
        return HttpClient.getClient().post(getEndpoint('/activity-community/'), request);
    }

    /** It updates spesific ActivityCommunity by id */
    async updateActivityCommunity(request: ActivityCommunityEntity): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().patch(getEndpoint('/activity-community/') + request.id, request);
    }

    /** It deletes spesific ActivityCommunity by id */
    async deleteActivityCommunity(id: string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().delete(getEndpoint('/activity-community/') + id);
    }
}
